module.exports = __webpack_public_path__ + "static/mongodb-df1d2359aae7f9411e1c768ccc998878.png";